import CustomHead from 'components/common/HeadMeta/HeadMeta'
import Template from 'components/download-completed'
import useLocalStorage from 'hooks/useLocalStorage'

const DownloadCompleted: React.FC = () => {
  const fromCorrectFormPage = useLocalStorage('refDownloadLeanPage')

  return (
    <>
      {fromCorrectFormPage && (
        <CustomHead
          keyword={'リーンキャンパス、フレームワーク、書き方、目的、記入例'}
          image={'https://aitria.co.jp/img/ogp_logo.png'}
          url={'https://aitria.co.jp/download/lean/done/'}
          title="ご入力いただきありがとうございます | リーンキャンバス | 資料ダウンロード | Aitria（アイトリア）"
          description="ご入力いただいたメールアドレス宛に資料ダウンロード用URLを送付いたしました。メールをご確認いただき、資料をダウンロードしてください。"
          noindexNofollow={true}
        />
      )}
      <Template />
    </>
  )
}

export default DownloadCompleted
